<template>
    <div>
        <div class="wrapper-overlay" v-if="overlay" @click="toggle = !toggle"></div>
        <main-nav in-nav @openMenu="toggle = !toggle"
                  ref="mainNav"
                  :toggle="toggle"
                  @incoming-call="handleIncomingCall"
                  @outcoming-call="handleOutcomingCall"
                  @showOutcomingModal="showOutComingModal = true"
                  @invalid-phone-number="handleInvalidPhoneNumber"
                  @worker-update="handleWorkerUpdate"
        />
        <section class="section" style="min-height: 70vh; padding-top: 70px;">
            <div class="is-fluid">
                <div class="columns">
                    <div class="shadow-menu column is-one-fifth is-hidden-touch">
                       <div class="menu-wrap">
                           <main-menu class="is-fixed"/>
                       </div>
                    </div>
                    <div class="column is-four-fifths is-12-touch">
                        <div v-if="this.$auth.check(['ivr_worker']) && this.$auth.user().worker.personal_phone">
                            <FormSwitch :label="followme"
                                        :value="this.$auth.user().worker.followme===1"
                                        @input="handleFollowme"></FormSwitch>
                        </div>
                        <div v-if="this.$auth.check(['ivr_worker']) && workerStatus === 'Offline'">
                            <twilio-warning></twilio-warning>
                        </div>
                        <router-view />
                    </div>
                </div>

            </div>
        </section>
        <main-footer></main-footer>
        <div ref="quickview" class="quickview is-left" :class="toggle?'is-active':''">
            <header class="quickview-header">
                <p class="title">Menu Principal</p>
                <span class="delete" @click="toggle = false"></span>
            </header>

            <div class="quickview-body">
                <div class="quickview-block">
                    <section class="section">
                        <div class="">
                            <main-menu @routeMenuUpdate="toggle = !toggle"/>
                        </div>
                    </section>
                </div>
            </div>

            <footer class="quickview-footer">

            </footer>
            <div class="mask"></div>
        </div>
        <!--<call-modal ref="modalcall" v-if="showModal && this.$auth.user().provider" :call="call" :provider="this.$auth.user().provider" @hangup="showModal = false"></call-modal>-->
        <!--<outcoming-modal ref="modalOutcomingCall"-->
                         <!--v-if="showOutComingModal &&  this.$auth.check(['ivr_worker'])"-->
                         <!--:provider="this.$auth.user().provider"-->
                         <!--@hideOutcomingModal="showOutComingModal = false"-->
                         <!--:workers="workers"-->
        <!--&gt;</outcoming-modal>-->
        <ivr v-if="this.$auth.check(['ivr_worker'])"
             :workers="workers"
             :worker-status="workerStatus"
             ref="ivr"></ivr>
    </div>
</template>

<script>
    import LaravelEcho from 'laravel-echo'
    export default {
        name: "MainLayout",
        data() {
            return {
                toggle: false,
                date: new Date(),
                overlay: false,
                showModal: false,
                showOutComingModal: false,
                call: {},
                workers: [],
                followme: this.$auth.user().worker===1?'Activar Sigueme':'Desactivar Sigueme',
                workerStatus: null
            }
        },
        mounted() {
            this.prepareComponent()
        },
        destroyed() {
            if(this.echo){
                this.echo.leave(`Workspace.${this.$auth.user().worker.workspace_id}`);
            }
        },
        watch: {
            toggle(val) {
                this.overlay =  val
                if (val) {
                    document.documentElement.classList.add('is-clipped')
                } else {
                    document.documentElement.classList.remove('is-clipped')
                }
            }
        },
        beforeRouteUpdate(to, from, next) {
            this.toggle = false;
            next()
        },
        methods: {
            prepareComponent() {
                if(this.$auth.check(['ivr_worker'])){
                    let Echo = new LaravelEcho(this.$backend.socketHeaders());
                    Echo.private(`Workspace.${this.$auth.user().worker.workspace_id}`).listen('Ivr\\WorkerStatusUpdateEvent', e => {
                        if(this.$auth && this.$auth.check(['ivr_worker'])) {
                            this.getWorkers()
                        }
                    });
                    this.getWorkers();
                    this.setWorkerOnline();
                }
            },
            handleMaskClick() {
                this.$refs.quickview.toggle()
            },
            handleIncomingCall(e) {
                this.showModal = true;
                this.call = e.data;
                setTimeout(() => {
                    this.$refs.modalcall.startRinging();
                }, 500);
            },
            handleOutcomingCall(e){
                this.$refs.modalOutcomingCall.connectCall();
            },
            handleInvalidPhoneNumber(){
                this.$refs.ivr.setValidPhoneNumber(false);
            },
            getWorkers(){
                return this.$http.get('/ivr/provider').then(response => {
                    this.workers = response.data;
                });
            },
            setWorkerOnline(){
                this.$http.post('/ivr/worker_update');
            },
            handleFollowme(e){
                if(e){
                    this.followme = 'Desactivar Sigueme';
                    this.$http.post('/ivr/worker_update', {activity:'FOLLOWME_ON'});
                }else{
                    this.followme = 'Activar Sigueme';
                    this.$http.post('/ivr/worker_update', {activity:'FOLLOWME_OFF'});
                }
            },
            handleWorkerUpdate(e){
                this.workerStatus = e.status;
            }
        }
    }
</script>

<style scoped>

</style>
